import React from "react";
import { ESTADOS_MATRICULA } from "../constants/estadosMatricula";
import { ESTADOS_PAGO } from "../constants/estadosPago";

export default function MatriculasFilters({ filtros, setFiltros, limpiarFiltros }) {
  return (
    <div className="management-card mat-filters-card management-filters-card mb-4">
      <div className="row g-3 align-items-end">
        <div className="col-12 col-md-4">
          <label className="form-label management-label mb-1">Buscar</label>
          <input
            type="search"
            className="form-control"
            placeholder="Estudiante, promoción, curso, centro o código de matrícula"
            value={filtros.search}
            onChange={(e) => setFiltros((prev) => ({ ...prev, search: e.target.value }))}
          />
        </div>
        <div className="col-6 col-md-2">
          <label className="form-label management-label mb-1">Desde</label>
          <input
            type="date"
            className="form-control"
            value={filtros.fecha_desde}
            max={filtros.fecha_hasta || undefined}
            onChange={(e) => setFiltros((prev) => ({ ...prev, fecha_desde: e.target.value }))}
          />
        </div>
        <div className="col-6 col-md-2">
          <label className="form-label management-label mb-1">Hasta</label>
          <input
            type="date"
            className="form-control"
            value={filtros.fecha_hasta}
            min={filtros.fecha_desde || undefined}
            onChange={(e) => setFiltros((prev) => ({ ...prev, fecha_hasta: e.target.value }))}
          />
        </div>
        <div className="col-6 col-md-2">
          <label className="form-label management-label mb-1">Estado matrícula</label>
          <select
            className="form-select"
            value={filtros.estado_matricula}
            onChange={(e) => setFiltros((prev) => ({ ...prev, estado_matricula: e.target.value }))}
          >
            <option value="all">Todos</option>
            {ESTADOS_MATRICULA.map((estado) => (
              <option key={estado.value} value={estado.value}>
                {estado.label}
              </option>
            ))}
          </select>
        </div>
        <div className="col-6 col-md-2">
          <label className="form-label management-label mb-1">Estado pago</label>
          <div className="input-group">
            <select
              className="form-select"
              value={filtros.estado_pago}
              onChange={(e) => setFiltros((prev) => ({ ...prev, estado_pago: e.target.value }))}
            >
              <option value="all">Todos</option>
              {ESTADOS_PAGO.map((estado) => (
                <option key={estado.value} value={estado.value}>
                  {estado.label}
                </option>
              ))}
            </select>
            <button type="button" className="btn management-btn-primary management-btn-tiny" onClick={limpiarFiltros}>
              <i className="bi bi-eraser-fill me-1" />
              Limpiar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
